export default __webpack_public_path__ + "static/media/wait_time.e4f240af.svg";